/* baitishk-custom.js — v43 (Taly: cart-page observer moved to the section wrapper's PARENT — baitishk-patches.js PATCH 4 replaces the whole section node after a rec add, which detached the v42 observer and silently killed Taly sync. v42: total from live text + drawer MutationObserver.) */
(function () {
  'use strict';

  var BTK_STR_FALLBACK = {
    add_to_cart: 'Add to Cart',
    sold_out: 'Sold Out',
    unavailable: 'Unavailable',
    added: 'Added',
    bundle_adding: 'Adding bundle...',
    bundle_added: 'Bundle added',
    bundle_error: 'Error — try again'
  };
  function btkStr(key) {
    var b = window.baitishkStrings;
    if (b && b[key]) return b[key];
    var c = window.cartStrings;
    if (c && c[key]) return c[key];
    return BTK_STR_FALLBACK[key] || '';
  }

  var DRAWER_ID = 'BaitishkDrawer';
  var drawer = null;
  var lastFocused = null;
  var scrollY = 0;

  function init() {
    drawer = document.getElementById(DRAWER_ID);
    if (!drawer) return;
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
      el.addEventListener('click', function (e) { e.stopPropagation(); closeDrawer(); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-baitishk-trigger]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    openDrawer(trigger);
  });

  function btkCartDrawerIsOpen() {
    if (!document.querySelector('cart-drawer')) return false;
    return document.documentElement.classList.contains('open-modal');
  }

  function openDrawer(trigger) {
    if (!drawer) return;
    lastFocused = trigger;
    var data;
    try {
      data = {
        id: trigger.dataset.productId,
        title: trigger.dataset.productTitle || '',
        vendor: trigger.dataset.productVendor || '',
        url: trigger.dataset.productUrl || '',
        image: trigger.dataset.productImage || '',
        variants: JSON.parse(trigger.dataset.variants || '[]'),
        optionNames: JSON.parse(trigger.dataset.optionNames || '[]')
      };
    } catch (err) { console.warn('[Baitishk] Invalid trigger data:', err); return; }
    var thumb  = drawer.querySelector('[data-drawer-thumb]');
    var vendor = drawer.querySelector('[data-drawer-vendor]');
    var title  = drawer.querySelector('[data-drawer-title]');
    var link   = drawer.querySelector('[data-drawer-details-link]');
    if (thumb)  { thumb.src = data.image; thumb.alt = data.title; }
    if (vendor) vendor.textContent = data.vendor;
    if (title)  title.textContent = data.title;
    if (link) { if (data.url) { link.href = data.url; link.style.display = ''; } else { link.style.display = 'none'; } }
    buildOptionGroups(data);
    updateSelection();
    var cartOpen = btkCartDrawerIsOpen();
    drawer.dataset.fromCartDrawer = cartOpen ? '1' : '0';
    if (!cartOpen) {
      scrollY = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = '-' + scrollY + 'px';
      document.body.style.width = '100%';
      drawer.dataset.lockedBody = '1';
    } else {
      drawer.dataset.lockedBody = '0';
    }
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    setTimeout(function () {
      var firstChip = drawer.querySelector('.baitishk-chip:not(.is-disabled)');
      if (firstChip) firstChip.focus();
    }, 100);
  }

  function closeDrawer() {
    if (!drawer || !drawer.classList.contains('is-open')) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (drawer.dataset.lockedBody === '1') {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    }
    drawer.dataset.lockedBody = '0';
    if (lastFocused) { try { lastFocused.focus(); } catch (e) {} }
  }

  function isColorOption(name) { return /color|colour|\u0644\u0648\u0646/i.test(name || ''); }

  function buildOptionGroups(data) {
    var body = drawer.querySelector('[data-drawer-body]');
    if (!body) return;
    body.innerHTML = '';
    body.dataset.variants = JSON.stringify(data.variants);
    body.dataset.optionNames = JSON.stringify(data.optionNames);
    data.optionNames.forEach(function (name, idx) {
      var group = document.createElement('div');
      group.className = 'baitishk-chip-group';
      group.dataset.optionIndex = idx;
      var isColor = isColorOption(name);
      var label = document.createElement('div');
      label.className = 'baitishk-chip-group__label';
      var labelName = document.createElement('span'); labelName.className = 'baitishk-chip-group__label-name'; labelName.textContent = name;
      var labelSep = document.createElement('span'); labelSep.className = 'baitishk-chip-group__label-sep'; labelSep.textContent = ': ';
      var labelValue = document.createElement('span'); labelValue.className = 'baitishk-chip-group__label-value';
      label.appendChild(labelName); label.appendChild(labelSep); label.appendChild(labelValue);
      group.appendChild(label);
      var chips = document.createElement('div');
      chips.className = 'baitishk-chip-group__chips';
      if (isColor) chips.classList.add('baitishk-chip-group__chips--swatch');
      var positionKey = 'option' + (idx + 1);
      var values = [], imageMap = {};
      data.variants.forEach(function (v) {
        var optVal = v[positionKey];
        if (!optVal) return;
        if (values.indexOf(optVal) === -1) values.push(optVal);
        if (isColor && !imageMap[optVal]) { var fi = v.featured_image; if (fi) imageMap[optVal] = typeof fi === 'string' ? fi : (fi.src || ''); }
      });
      values.forEach(function (val, i) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.dataset.value = val;
        if (isColor && imageMap[val]) {
          chip.className = 'baitishk-chip baitishk-chip--swatch';
          chip.setAttribute('aria-label', val); chip.title = val;
          var imgEl = document.createElement('img'); imgEl.src = imageMap[val]; imgEl.alt = val; imgEl.loading = 'lazy';
          chip.appendChild(imgEl);
        } else { chip.className = 'baitishk-chip'; chip.textContent = val; }
        if (i === 0) { chip.classList.add('is-selected'); labelValue.textContent = val; }
        chip.addEventListener('click', function () { selectChip(this); });
        chips.appendChild(chip);
      });
      group.appendChild(chips);
      body.appendChild(group);
    });
  }

  function selectChip(chip) {
    var group = chip.closest('.baitishk-chip-group');
    if (!group) return;
    group.querySelectorAll('.baitishk-chip').forEach(function (c) { c.classList.remove('is-selected'); });
    chip.classList.add('is-selected');
    var valueEl = group.querySelector('.baitishk-chip-group__label-value');
    if (valueEl) valueEl.textContent = chip.dataset.value;
    updateSelection();
  }

  function updateSelection() {
    var body = drawer.querySelector('[data-drawer-body]');
    if (!body) return;
    var variants;
    try { variants = JSON.parse(body.dataset.variants); } catch (e) { return; }
    var selected = [];
    body.querySelectorAll('.baitishk-chip-group').forEach(function (g) {
      var s = g.querySelector('.baitishk-chip.is-selected');
      selected.push(s ? s.dataset.value : null);
    });
    var variant = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i]; var match = true;
      for (var j = 0; j < selected.length; j++) {
        if (selected[j] && v['option' + (j + 1)] !== selected[j]) { match = false; break; }
      }
      if (match) { variant = v; break; }
    }
    var atc = drawer.querySelector('[data-drawer-atc]');
    var price = drawer.querySelector('[data-drawer-price]');
    var label = drawer.querySelector('.baitishk-drawer__atc-label');
    var thumb = drawer.querySelector('[data-drawer-thumb]');
    if (variant) {
      drawer.dataset.variantId = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (atc) atc.disabled = !variant.available;
      if (label) label.textContent = variant.available ? btkStr('add_to_cart') : btkStr('sold_out');
      if (thumb && variant.featured_image) {
        var vimg = typeof variant.featured_image === 'string' ? variant.featured_image : (variant.featured_image.src || '');
        if (vimg && thumb.src !== vimg) {
          thumb.style.opacity = '0.4';
          var preload = new Image();
          preload.onload = function () { thumb.src = vimg; thumb.style.opacity = '1'; };
          preload.onerror = function () { thumb.style.opacity = '1'; };
          preload.src = vimg;
        }
      }
    } else {
      drawer.dataset.variantId = '';
      if (atc) atc.disabled = true;
      if (label) label.textContent = btkStr('unavailable');
    }
    updateChipAvailability(variants, selected);
  }

  function updateChipAvailability(variants, selected) {
    var body = drawer.querySelector('[data-drawer-body]');
    if (!body) return;
    body.querySelectorAll('.baitishk-chip-group').forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex);
      group.querySelectorAll('.baitishk-chip').forEach(function (chip) {
        var val = chip.dataset.value; var hasAvailable = false;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v['option' + (idx + 1)] !== val) continue;
          var match = true;
          for (var j = 0; j < selected.length; j++) {
            if (j === idx) continue;
            if (selected[j] && v['option' + (j + 1)] !== selected[j]) { match = false; break; }
          }
          if (match && v.available) { hasAvailable = true; break; }
        }
        chip.classList.toggle('is-disabled', !hasAvailable);
      });
    });
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var format = (window.themeGlobalVariables && window.themeGlobalVariables.settings && window.themeGlobalVariables.settings.money_format) || '{{amount}}';
    var dollars = (cents / 100).toFixed(3);
    var formatted = format
      .replace('{{amount}}', dollars)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount_with_comma_separator}}', dollars.replace('.', ','))
      .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100));
    return formatted.replace(/<[^>]*>/g, '').trim();
  }

  /* ── TALY LIVE REFRESH ──────────────────────────────────────────────────
     The Taly widget is server-rendered (drawer footer + two cart-page blocks)
     and the theme's partial DOM swaps never touch it. The Liquid renders every
     wrap unconditionally (hidden inline below the minimum); this JS keeps ALL
     .btk-taly-wrap elements in sync with the live total.
     TOTAL SOURCE: the visible total TEXT is the only value the theme reliably
     refreshes on quantity changes — the progress bar's data-total-order stays
     frozen at its page-load value — so parse the text first and use the data
     attribute only as a fallback.
     TRIGGERS: MutationObservers on the drawer section and the cart page
     (the theme's event names for qty changes are not dependable), plus the
     cart:updated/cart:refresh events our own ATC handlers dispatch.
     UNITS: Shopify money values are in HUNDREDTHS (cents) even for KWD —
     KWD 5.990 is 599 cents. Taly minimum order is KWD 10.000 = 1000 cents.
     Change-guards (only write when the value differs) are required because
     the observers watch subtrees that contain the wraps — unconditional
     writes would loop.
  ─────────────────────────────────────────────────────────────────────────── */
  var BTK_TALY_MIN_CENTS = 1000; // KWD 10.000 — Taly minimum order value
  var btkLastTotalCents = null;

  /* Parse KWD cents from a formatted string like "12.500 KWD" (12.500 -> 1250) */
  function btkParseTotalCents(moneyStr) {
    var cleaned = (moneyStr || '').replace(/[^\d.,]/g, '').replace(',', '.');
    return Math.round((parseFloat(cleaned) || 0) * 100);
  }

  /* Best available live total, in cents. Visible total text FIRST — it is the
     only source the theme refreshes on qty changes; data-total-order is only
     fresh at page load or after our own section swap. */
  function btkResolveTotalCents() {
    var txt = document.querySelector('cart-drawer .total-price') || document.querySelector('#MainCartItems .total_price-inner');
    if (txt) {
      var parsed = btkParseTotalCents(txt.textContent);
      if (parsed > 0) return parsed;
    }
    var el = document.querySelector('cart-drawer .progress') || document.querySelector('#MainCartItems .progress');
    if (el && el.dataset.totalOrder !== undefined) {
      var v = parseFloat(el.dataset.totalOrder);
      if (!isNaN(v)) return v;
    }
    return null;
  }

  function btkRefreshTaly(cartTotalCents) {
    if (cartTotalCents === null || cartTotalCents === undefined || isNaN(cartTotalCents)) return;
    btkLastTotalCents = cartTotalCents;
    var wraps = document.querySelectorAll('.btk-taly-wrap');
    if (!wraps.length) return;
    var installmentKwd = (Math.round(cartTotalCents * 0.25) / 100).toFixed(3);
    wraps.forEach(function (wrap) {
      if (cartTotalCents < BTK_TALY_MIN_CENTS) {
        if (wrap.style.display !== 'none') wrap.style.display = 'none';
        return;
      }
      if (wrap.style.display !== '') wrap.style.display = '';
      var isArabic = wrap.getAttribute('dir') === 'rtl';
      var titleEl = wrap.querySelector('.btk-taly-title');
      if (titleEl) {
        var newText = isArabic
          ? '\u0642\u0633\u0651\u0645 \u0639\u0644\u0649 4 \u062f\u0641\u0639\u0627\u062a \u0628\u0642\u064a\u0645\u0629 KWD ' + installmentKwd
          : 'Split into 4 payments of KWD ' + installmentKwd;
        if (titleEl.textContent !== newText) titleEl.textContent = newText;
      }
    });
  }

  function refreshCartDrawerSection(html) {
    if (!html) return false;
    var existing = document.querySelector('cart-drawer');
    if (!existing) return false;
    try {
      var temp = document.createElement('div');
      temp.innerHTML = html.trim();
      var newEl = temp.querySelector('cart-drawer');
      if (newEl) { existing.replaceWith(newEl); return true; }
      var wrapper = existing.closest('[id^="shopify-section-"]');
      if (wrapper) { wrapper.innerHTML = html; return true; }
    } catch (err) { console.warn('[Baitishk] Cart drawer refresh failed:', err); }
    return false;
  }

  function btkUpdateCartContents(html) {
    if (!html) return;
    try {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var swaps = [
        ['#CartDrawer-CartItems', '#CartDrawer-CartItems'],
        ['cart-drawer .total-price', 'cart-drawer .total-price'],
        ['cart-drawer .drawer__heading .cart-count', 'cart-drawer .drawer__heading .cart-count'],
        ['cart-drawer .subtotal-price-label', 'cart-drawer .subtotal-price-label'],
        ['cart-drawer .progress-bar-message', 'cart-drawer .progress-bar-message']
      ];
      swaps.forEach(function (p) {
        var newEl = temp.querySelector(p[0]);
        var oldEl = document.querySelector(p[1]);
        if (newEl && oldEl) oldEl.innerHTML = newEl.innerHTML;
      });
      var newProgress = temp.querySelector('cart-drawer .progress');
      var oldProgress = document.querySelector('cart-drawer .progress');
      if (newProgress && oldProgress) {
        var newTotal = newProgress.dataset.totalOrder;
        if (newTotal !== undefined) {
          oldProgress.dataset.totalOrder = newTotal;
          var minAmount = parseFloat(oldProgress.dataset.feAmount || '30');
          var totalCents = parseFloat(newTotal || '0');
          var pct = Math.min((totalCents / (minAmount * 100)) * 100, 100);
          oldProgress.style.width = pct + '%';
          btkRefreshTaly(totalCents);
        }
      } else {
        setTimeout(function () { btkRefreshTaly(btkResolveTotalCents()); }, 60);
      }
      btkCenterDrawerCount();
    } catch (err) { console.warn('[Baitishk] Update contents failed:', err); }
  }

  function patchHeaderCartBadge(count) {
    var n = parseInt(count, 10);
    if (isNaN(n)) n = (count === '~') ? 100 : 0;
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    cartIcon.querySelectorAll('.cart-count').forEach(function (el) { el.remove(); });
    var badge = document.createElement('div');
    if (n > 0) {
      badge.className = 'absolute inline-flex content-center cart-count rounded-50 bg-sale fs-10';
      var displayCount = n < 100 ? String(n) : '~';
      badge.innerHTML = '<span class="count">' + displayCount + '</span><span class="visually-hidden">' + n + '</span>';
      cartIcon.appendChild(badge);
    } else {
      badge.className = 'hidden cart-count';
      badge.innerHTML = '<span aria-hidden="true">0</span>';
      cartIcon.appendChild(badge);
    }
    var actionParent = cartIcon.closest('.header__action');
    if (actionParent) {
      if (n === 0) actionParent.classList.add('header__action_cart_empty');
      else actionParent.classList.remove('header__action_cart_empty');
    }
  }

  function btkDedupeCartBadge() {
    var cartIcon = document.getElementById('cart-icon-bubble');
    if (!cartIcon) return;
    var badges = cartIcon.querySelectorAll('.cart-count');
    if (badges.length < 2) return;
    var keep = cartIcon.querySelector('.cart-count.bg-sale');
    badges.forEach(function (el) { if (el !== keep) el.remove(); });
  }
  document.addEventListener('cart:updated', function () { setTimeout(btkDedupeCartBadge, 50); });
  document.addEventListener('cart:refresh', function () { setTimeout(btkDedupeCartBadge, 50); });

  function btkSuppressSticky() {
    var s = document.querySelector('sticky-add-cart');
    if (!s) return;
    s.classList.add('btk-sticky-suppressed');
    clearTimeout(btkSuppressSticky._t);
    btkSuppressSticky._t = setTimeout(function () { s.classList.remove('btk-sticky-suppressed'); }, 4000);
  }
  document.addEventListener('cart:updated', btkSuppressSticky);
  document.addEventListener('nextsky:cart:added', btkSuppressSticky);

  function extractCountFromCartDrawerHtml(html) {
    if (!html) return null;
    try {
      var temp = document.createElement('div');
      temp.innerHTML = html;
      var src = temp.querySelector('.cart-count');
      return src ? (src.textContent || '').trim() : null;
    } catch (err) { return null; }
  }

  function btkCenterDrawerCount() {
    document.querySelectorAll('cart-drawer .drawer__heading .cart-count').forEach(function (el) {
      if (el.querySelector('.btk-count-num')) return;
      var t = (el.textContent || '').trim();
      if (!t) return;
      el.textContent = '';
      var s = document.createElement('span'); s.className = 'btk-count-num'; s.textContent = t;
      el.appendChild(s);
    });
  }
  function btkScheduleCount() { setTimeout(btkCenterDrawerCount, 350); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', btkCenterDrawerCount);
  else btkCenterDrawerCount();
  document.addEventListener('cart:updated', btkScheduleCount);
  document.addEventListener('cart:refresh', btkScheduleCount);

  /* Taly refresh on our own cart events (drawer ATC / recs / bundle flows) */
  ['cart:updated', 'cart:refresh'].forEach(function (evt) {
    document.addEventListener(evt, function () {
      setTimeout(function () { btkRefreshTaly(btkResolveTotalCents()); }, 400);
    });
  });

  /* Taly refresh via MutationObservers — the theme's own qty-change flows swap
     item lists and total text without firing dependable events and without
     touching the Taly wraps. Watch the drawer section wrapper (survives full
     cart-drawer replacement) and, on the cart page, the PARENT of the cart
     section wrapper — baitishk-patches.js PATCH 4 replaces the entire
     [id^="shopify-section-"] node after a recommendation add, which would
     detach an observer bound to the section or anything inside it and
     silently kill Taly sync for the rest of the session. Debounced, with
     change-guards in btkRefreshTaly stopping feedback loops. */
  function btkObserveForTaly(target) {
    if (!target || !('MutationObserver' in window)) return;
    var t = null;
    var obs = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(function () { btkRefreshTaly(btkResolveTotalCents()); }, 200);
    });
    obs.observe(target, { childList: true, subtree: true, characterData: true });
  }
  function btkInitTalyObservers() {
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl) {
      btkObserveForTaly(drawerEl.closest('[id^="shopify-section-"]') || drawerEl.parentNode || drawerEl);
    }
    var mainCart = document.getElementById('MainCartItems');
    if (mainCart) {
      var sec = mainCart.closest('[id^="shopify-section-"]');
      btkObserveForTaly((sec && sec.parentNode) || sec || mainCart);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', btkInitTalyObservers);
  else btkInitTalyObservers();

  /* Delegated Taly modal open/close — class-based, so it also serves the
     cart-page desktop block whose inline script binds the wrong elements
     (duplicate IDs across the two server-rendered blocks), and it always
     uses the LIVE total for the iframe price instead of the page-load one.
     Runs after the inline handlers (document-level, bubble phase), so its
     iframe src wins. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.btk-taly-btn');
    if (btn) {
      var wrap = btn.closest('.btk-taly-wrap');
      var modal = null;
      if (wrap && wrap.nextElementSibling && wrap.nextElementSibling.classList && wrap.nextElementSibling.classList.contains('btk-taly-modal')) {
        modal = wrap.nextElementSibling;
      } else {
        modal = document.querySelector('.btk-taly-modal');
      }
      if (!modal) return;
      var cents = (btkLastTotalCents !== null) ? btkLastTotalCents : btkResolveTotalCents();
      var iframe = modal.querySelector('.btk-taly-iframe');
      if (iframe && cents !== null) {
        var isArabic = wrap && wrap.getAttribute('dir') === 'rtl';
        iframe.src = 'https://promo.taly.io/how-it-works?price=' + (cents / 100).toFixed(3) + '&installmenttype=4&lang=' + (isArabic ? 'ar' : 'en');
      }
      modal.classList.add('active');
      var box = modal.querySelector('.btk-taly-modal-box');
      if (box) { try { box.focus(); } catch (err) {} }
      return;
    }
    var closeBtn = e.target.closest('.btk-taly-modal-close');
    if (closeBtn) {
      var m = closeBtn.closest('.btk-taly-modal');
      if (m) m.classList.remove('active');
      return;
    }
    if (e.target && e.target.classList && e.target.classList.contains('btk-taly-modal')) {
      e.target.classList.remove('active');
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('.btk-taly-modal.active').forEach(function (m) { m.classList.remove('active'); });
  });

  /* ATC handler (variant picker drawer) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-drawer-atc]');
    if (!btn || !drawer) return;
    if (btn.disabled) return;
    if (!drawer.dataset.variantId) return;
    btn.disabled = true;
    var label = btn.querySelector('.baitishk-drawer__atc-label');
    var origText = label ? label.textContent : '';
    if (label) label.textContent = '...';
    var fromCartDrawer = drawer.dataset.fromCartDrawer === '1';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(drawer.dataset.variantId), quantity: 1, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
    .then(function (res) { if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Error'); }); return res.json(); })
    .then(function (data) {
      btn.classList.add('is-success');
      if (label) label.textContent = '\u2713 ' + btkStr('added');
      var cartDrawerHtml = data && data.sections && data.sections['cart-drawer'];
      if (cartDrawerHtml) {
        var count = extractCountFromCartDrawerHtml(cartDrawerHtml);
        if (count !== null) patchHeaderCartBadge(count);
        if (fromCartDrawer) btkUpdateCartContents(cartDrawerHtml);
        else refreshCartDrawerSection(cartDrawerHtml);
      } else {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { patchHeaderCartBadge(cart.item_count || 0); }).catch(function () {});
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      setTimeout(function () { closeDrawer(); btn.classList.remove('is-success'); if (label) label.textContent = origText; btn.disabled = false; if (drawer) drawer.dataset.fromCartDrawer = '0'; }, 1000);
    })
    .catch(function (err) { console.warn('[Baitishk] Drawer ATC:', err); if (label) label.textContent = origText; btn.disabled = false; });
  });

  /* CART-DRAWER RECS — single-variant direct add */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-btk-rec-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.dataset.btkBusy === '1') return;
    var variantId = btn.dataset.variantId;
    if (!variantId) return;
    btn.dataset.btkBusy = '1';
    btn.classList.add('btk-rec-loading');
    var label = btn.querySelector('.btk-rec-card__add-label');
    var origText = label ? label.textContent : '';
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
    .then(function (res) { if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Error'); }); return res.json(); })
    .then(function (data) {
      btn.classList.remove('btk-rec-loading'); btn.classList.add('btk-rec-added');
      if (label) label.textContent = '\u2713 ' + btkStr('added');
      var cartDrawerHtml = data && data.sections && data.sections['cart-drawer'];
      if (cartDrawerHtml) {
        var count = extractCountFromCartDrawerHtml(cartDrawerHtml);
        if (count !== null) patchHeaderCartBadge(count);
        btkUpdateCartContents(cartDrawerHtml);
      } else {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { patchHeaderCartBadge(cart.item_count || 0); }).catch(function () {});
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      setTimeout(function () { btn.classList.remove('btk-rec-added'); if (label) label.textContent = origText; btn.dataset.btkBusy = ''; }, 1600);
    })
    .catch(function (err) { console.warn('[Baitishk Recs] add failed:', err); btn.classList.remove('btk-rec-loading'); if (label) label.textContent = origText; btn.dataset.btkBusy = ''; });
  });

  /* BUNDLE PACK HANDLER (FBT) */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-bundle-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    var companionStr = (btn.dataset.companionVariants || '').trim();
    var companionIds = companionStr ? companionStr.split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [];
    var mainForm = document.querySelector('form[action*="/cart/add"]');
    var anchorVariantInput = mainForm ? mainForm.querySelector('input[name="id"]') : null;
    var anchorVariantId = anchorVariantInput ? anchorVariantInput.value : null;
    if (!anchorVariantId || companionIds.length === 0) { console.warn('[Baitishk Bundle] Missing variant data'); return; }
    var items = [{ id: Number(anchorVariantId), quantity: 1 }];
    companionIds.forEach(function (vid) { var n = Number(vid); if (n && !isNaN(n)) items.push({ id: n, quantity: 1 }); });
    btn.disabled = true;
    var label = btn.querySelector('.baitishk-bundle__add-label');
    var origText = label ? label.textContent : '';
    if (label) label.textContent = btkStr('bundle_adding');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items, sections: 'cart-drawer', sections_url: window.location.pathname })
    })
    .then(function (res) { if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Error'); }); return res.json(); })
    .then(function (data) {
      btn.classList.add('is-success');
      if (label) label.textContent = '\u2713 ' + btkStr('bundle_added');
      var cartDrawerHtml = data && data.sections && data.sections['cart-drawer'];
      if (cartDrawerHtml) {
        var count = extractCountFromCartDrawerHtml(cartDrawerHtml);
        if (count !== null) patchHeaderCartBadge(count);
        refreshCartDrawerSection(cartDrawerHtml);
      } else {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) { patchHeaderCartBadge(cart.item_count || 0); }).catch(function () {});
      }
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      setTimeout(function () { btn.classList.remove('is-success'); if (label) label.textContent = origText; btn.disabled = false; }, 2200);
    })
    .catch(function (err) {
      console.warn('[Baitishk Bundle] Add failed:', err);
      btn.classList.add('is-error');
      if (label) label.textContent = btkStr('bundle_error');
      setTimeout(function () { btn.classList.remove('is-error'); if (label) label.textContent = origText; btn.disabled = false; }, 2500);
    });
  });

}());
